// extracted by mini-css-extract-plugin
export default {"indent":"_Poti6zCidccTBBobott"};